//  * @package         src/components/Editresponse
//  * @author          Parimal A Ghadiyali
//  * @date            16 June 2022
//  * @type            Editresponse middle Content Component File
//  * @description -   This file renders the html and functionality for center component when questions tab is choosed.
<template>
  <div class="content preview_content">
    <v-wait for="adding response">
      <template slot="waiting">
        <div id="loadingDiv" class="loadingDiv_analytics">
          <div class="loadersec">
            <div class="loader"></div>
          </div>
      </div>
      </template>
    </v-wait>
    
    <div class="service-provide-info searchHeader">
      <div
        class="persnol-info-main qus_ans_sec"
      >
        <label class="persnol-info-title searchHeader">
          Search by postcode:
        </label>

        <div class="group">
          <div class="searchInput">
            <form @submit.prevent>
              <input
                type="text"
                placeholder="What postcode you are searching?"
                name="txt_search_value"
                v-validate="{required: true}"
                data-vv-as="above"
                v-model="searchValue"
                :class="{'inputBgColor': bgColorShown}"
                v-on:keyup="searchValue ? '' : checkInput()"
                autocomplete="off"
              />
              <button type="submit" @click="checkInput"> <img src="/static/images/search-white.png" alt="search-icon"> </button>
            </form>
          </div>

          <span
            :class="['showSearchText', searchResponseShown ]"
          >
            <div v-if="searchResponse.flag" class="actualOutput2">
              <i class="fas fa-calendar-check fa-4x"></i>
                <p> {{ vueConfig.searchLastResponseDate }}</p>
                <h5>{{ searchResponse.data.dt_date_collected }}</h5>
            </div>
            <div v-else class="actualOutput">
              <i class="fa fa-exclamation-circle fa-4x" aria-hidden="true"></i>
              <label>No records found</label>
            </div>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
var vueConfig = require("../../../config/config.js");

export default {
  name: "Content",
  metaInfo() {
    return {
      title: this.siteTitle,
    };
  },
  props: ["siteTitle"],
  components: {},
  computed: {
    ...mapGetters("previewSurvey", [
      'searchResponse',
    ])
  },
  data() {
    return {
      vueConfig: vueConfig,
      bgColorShown: false,
      searchValue: '',
      searchResponseShown: 'hide',
    };
  },
  methods: {
    ...mapActions("previewSurvey", ["searchResponseBySurveyId"]),
    hispec() {
      // var parts = window.location.href.split(".");
      let whitelabel = this.$session.get("whitelabel");
      var loc =
        vueConfig.frontHostName +
        process.env.CAKE_BASE_PATH +
        whitelabel +
        process.env.CAKE_SURVEY_PATH;
      // var loc = "http://" + location.hostname + process.env.CAKE_SURVEY_PATH;
      window.location.href = loc;
    },
    async checkInput(){
      this.data = this.$session.getAll();
      this.data["in_survey_Id_normal"] = this.data.in_survey_Id;
      this.data["in_survey_Id"] = this.$route.params.sid;
      this.data["search_text"] = this.searchValue;
      this.bgColorShown = this.searchValue ? true : false;
      await this.searchResponseBySurveyId(this.data);
      this.searchResponseShown = this.searchValue ? 'show' : 'hide';
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/SearchResponse/Content.vue